export default "__VITE_ASSET__CcEQqPFO__"